import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import touchEnabled from '../lib/touch-enabled';

export default function Layout({ children, theme, id }) {
  const bodyAttributes = {
    class: theme + (touchEnabled() ? ' touch-enabled' : ' touch-disabled'),
  };
  return (
    <>
      <Helmet bodyAttributes={bodyAttributes} />
      <div id={id} className="container">
        {children}
      </div>
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};
